import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  dialogPaper: {
    overflowY: 'auto',
    minHeight: 'auto',
    borderRadius: theme.tokens.radius.l,
    flexGrow: 1,
    [theme.breakpoints.up('md')]: {
      minWidth: theme.px(668),
    },

    '& > form': {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    },
  },
  dialogWithoutRadius: {
    borderRadius: 0,
  },
}));
